module.exports = __webpack_public_path__ + "assets/img/img3.cd7e2cf0.png";